import { createAccessibilityStatementReadable } from "../Services/game";
import { State } from "./State";
export class Game {
    constructor(startVideo, endVideo, checkpoints) {
        this.startVideo = startVideo;
        this.endVideo = endVideo;
        this.checkpoints = checkpoints;
        /**
         * Almacena los targets actuales
         * Los targets son todos aquellos checkpoints accesibles y no completados
         */
        this.targets = new State([]);
        /**
         * Almacena todos los checkpoints completados
         */
        this.completed = new State([]);
        checkpoints.forEach(checkpoint => {
            const mustVisible = createAccessibilityStatementReadable(checkpoints, checkpoint.accesibility.visibleOn);
            const mustAccesible = createAccessibilityStatementReadable(checkpoints, checkpoint.accesibility.accesibleOn);
            mustVisible.subscribe(value => checkpoint.setVisible(value));
            mustAccesible.subscribe(value => checkpoint.setAccesible(value));
            checkpoint.isCompleted.subscribe(() => this.addToCompleted(checkpoint));
            checkpoint.isTarget.subscribe(() => this.updateTargets());
            checkpoint.isAccesible.subscribe(() => this.updateTargets());
        });
    }
    getFirstTarget() {
        const [target] = this.targets.value;
        return target || null;
    }
    allCheckpointsCompleted() {
        return this.checkpoints.every(({ isCompleted }) => isCompleted.value);
    }
    /**
     * Actualiza el estado de targets
     */
    updateTargets() {
        const targets = this.checkpoints.filter(checkpoint => checkpoint.getIsTarget());
        if (targets.length === this.targets.value.length && targets.every(({ id }) => this.targets.value.some(target => id === target.id))) {
            //Los targets no han cambiado
            return;
        }
        this.targets.set(targets);
    }
    addToCompleted(checkpoint) {
        if (!checkpoint.isCompleted.value) {
            return;
        }
        this.completed.set([...this.completed.value, checkpoint]);
    }
}
